'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

require('antd/lib/form/style');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 },
    md: { span: 10 }
  }
};
var tailFormItemLayout = {
  4: {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0
      },
      sm: {
        span: 14,
        offset: 8
      }
    }
  },
  6: {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0
      },
      sm: {
        span: 14,
        offset: 8
      }
    }
  },
  12: {
    wrapperCol: {
      xs: {
        span: 24,
        offset: 0
      },
      sm: {
        span: 14,
        offset: 8
      }
    }
  }
};

var FieldTemplate = function FieldTemplate(props) {
  var classNames = props.classNames,
      description = props.description,
      rawErrors = props.rawErrors,
      children = props.children,
      errors = props.errors,
      required = props.required,
      schema = props.schema,
      type = props.type;
  // console.log('errors: ', rawErrors);
  // console.log('errors: ', props);

  return type === 'object' || type === undefined && schema.type === 'object' ? children : schema.widget === 'checkbox' ? _react2.default.createElement(
    FormItem,
    Object.assign({}, tailFormItemLayout[schema.column], {
      className: classNames + ' ant-col-xl-' + schema.column * 2,
      help: errors,
      required: required
    }),
    children
  ) : _react2.default.createElement(
    FormItem,
    Object.assign({}, formItemLayout, {
      className: classNames + ' ant-col-xl-' + schema.column * 2,
      hasFeedback: true,
      label: schema.label,
      help: rawErrors,
      extra: description,
      validateStatus: rawErrors.length ? 'error' : '',
      required: required
    }),
    children
  );
};

FieldTemplate.defaultProps = {
  errors: [],
  rawErrors: [],
  help: [],
  description: '',
  classNames: '',
  required: false,
  type: undefined,
  label: ''
};

FieldTemplate.propTypes = {
  classNames: _propTypes2.default.string,
  label: _propTypes2.default.string,
  id: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.object,
  children: _propTypes2.default.object.isRequired,
  errors: _propTypes2.default.object,
  help: _propTypes2.default.object,
  required: _propTypes2.default.bool,
  schema: _propTypes2.default.object.isRequired,
  type: _propTypes2.default.string
};

exports.default = FieldTemplate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/Form/FieldTemplates/FieldTemplate/index.js
// module id = 1028
// module chunks = 0